module.exports = __webpack_public_path__ + "static/uhc-logo-full-076c17cdd76ce8f16ca3b756906cf702.svg";